import React from 'react';
import { candidateData } from '../mock';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import VisionSection from '../components/VisionSection';
import CommitmentsSection from '../components/CommitmentsSection';
import AchievementsSection from '../components/AchievementsSection';
import ContactSection from '../components/ContactSection';
import Header from '../components/Header';
import Footer from '../components/Footer';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Header />
      <HeroSection data={candidateData.heroSection} />
      <AboutSection data={candidateData.about} />
      <VisionSection data={candidateData.vision} />
      <CommitmentsSection commitments={candidateData.commitments} />
      <AchievementsSection data={candidateData.achievements} />
      <ContactSection data={candidateData.contact} />
      <Footer motto={candidateData.motto} />
    </div>
  );
};

export default LandingPage;
